import { interviewerSessionHref } from '@yeshuman/sdk'

import type { InterviewerCandidateRow } from '../hooks/use-interviewer-candidates'

/** Session link for an interview-queue row; carries the brief and application for the kit and scorecard. */
export function interviewerCandidateSessionHref(
  row: InterviewerCandidateRow,
  { label, interviewId }: { label: string; interviewId?: string | null },
): string {
  const href = interviewerSessionHref({
    profileId: row.profile.id,
    opportunityId: row.opportunity_id,
    label,
    interviewId: interviewId ?? undefined,
    liveSessionId: row.live_session_id,
  })
  const extra = new URLSearchParams()
  if (row.brief_id) extra.set('briefId', row.brief_id)
  if (row.id) extra.set('applicationId', row.id)
  const qs = extra.toString()
  if (!qs) return href
  return `${href}${href.includes('?') ? '&' : '?'}${qs}`
}
